import { translate } from 'react-jhipster';

export const optionsTypeAddress = () => [
  { label: translate('userManagement.address.type.PRIVATE'), value: 'PRIVATE' },
  { label: translate('userManagement.address.type.OFFICE'), value: 'OFFICE' },
  { label: translate('userManagement.address.type.HEAD_QUARTER'), value: 'HEAD_QUARTER' },
];
